import { useState, useEffect } from 'react'

type AlertState = {
  type: 'success' | 'error'
  title?: string
  message: string
  open: boolean
}

let _state: AlertState = { type: 'success', message: '', open: false }
const _listeners = new Set<() => void>()
const _notify = () => _listeners.forEach((fn) => fn())

export const useAlertState = (): AlertState => {
  const [state, setState] = useState(_state)
  useEffect(() => {
    const listener = () => setState({ ..._state })
    _listeners.add(listener)
    return () => { _listeners.delete(listener) }
  }, [])
  return state
}

export const closeAlert = () => {
  _state = { ..._state, open: false }
  _notify()
}

export const showSuccess = (message: string) => {
  _state = { type: 'success', message, open: true }
  _notify()
}

export const showError = (message: string) => {
  _state = { type: 'error', title: 'Oops...', message, open: true }
  _notify()
}
